import { Row, Col, Space, Typography } from "antd";
import BorderedLink from "~/components/app/BorderedLink";
import { useRouter } from "next/router";

const { Text } = Typography;

const RECRUITMENT_TYPES = [
  { value: "", label: "全部" },
  { value: "jd", label: "社区帖子招聘" },
  { value: "jobs_channel", label: "简历智能匹配" },
  { value: "talent", label: "精选职位推荐" },
];

const RecruitmentTypeFilter = ({ preserveParams = [] }) => {
  const router = useRouter();
  const [pathname] = router.asPath.split("?");
  const currentType = router.query.recruitment_type || "";

  const urlForType = (typeValue) => {
    // Preserve specified query parameters
    const query = {};
    preserveParams.forEach((param) => {
      if (router.query[param] !== undefined) {
        query[param] = router.query[param];
      }
    });

    // Add recruitment_type if not empty
    if (typeValue) {
      query.recruitment_type = typeValue;
    }

    // Build the query string
    const queryString = new URLSearchParams(query).toString();

    return queryString ? `${pathname}?${queryString}` : pathname;
  };

  return (
    <Row
      align="middle"
      gutter={[6, 10]}
      style={{ fontSize: "0.8rem" }}
    >
      <Col flex="80px">
        <Text strong>招聘方式</Text>
      </Col>
      <Col flex="1">
        <Row
          justify="start"
          align="middle"
          gutter={[6, 8]}
        >
          {RECRUITMENT_TYPES.map((type, index) => (
            <Col key={type.value || `all-${index}`}>
              <BorderedLink
                href={urlForType(type.value)}
                active={currentType === type.value}
              >
                {type.label}
              </BorderedLink>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default RecruitmentTypeFilter;
